module.exports = __webpack_public_path__ + "static/media/foto3.808cd53b.png";